import "./modal-background.scss";
import { HTMLAttributes, MouseEvent, RefObject, useState } from "react";

interface ModalBackgroundProps extends HTMLAttributes<HTMLDivElement> {
  innerComponentRef: RefObject<HTMLElement>;
  callback: () => void;
}

function ModalBackground({ innerComponentRef, callback, children }: ModalBackgroundProps) {
  const [isMouseDownTriggeredInside, setIsMouseDownTriggeredInside] = useState<boolean>(false);

  function handleMouseDown(event: MouseEvent<HTMLElement>) {
    if (!innerComponentRef.current) return;
    setIsMouseDownTriggeredInside(innerComponentRef.current.contains(event.target as Node));
  }

  function handleMouseUp(event: MouseEvent<HTMLElement>) {
    if (isMouseDownTriggeredInside) return;

    if (!innerComponentRef.current) return;

    if (innerComponentRef.current.contains(event.target as Node)) return;

    callback();
  }

  return (
    <div className="polymer-modal-background" onMouseDown={handleMouseDown} onMouseUp={handleMouseUp}>
      {children}
    </div>
  );
}

export { ModalBackground };
